import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["dataSource", "title", "list", "columns"],
  _excluded2 = ["render"];
// import { convertToStoryboard } from "./raw-data-generate/convert.js";
// import { getPreGeneratedAttrViews } from "./getPreGeneratedAttrViews.js";
import { parseDataSource } from "./expressions.js";
// import { findObjectIdByUsedDataContexts } from "./findObjectIdByUsedDataContexts.js";
import { convertComponent } from "./convertComponent.js";
import { deepReplaceVariables } from "./deepReplaceVariables.js";
export default function convertDescriptions(_x, _x2, _x3, _x4, _x5) {
  return _convertDescriptions.apply(this, arguments);
}
function _convertDescriptions() {
  _convertDescriptions = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref, mod, state, options, scope) {
    var properties, _ref2, dataSource, title, list, columns, restProps, parsedDataSource, configuredItems, convertedList, _t;
    return _regeneratorRuntime().wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          properties = _ref.properties;
          _ref2 = properties, dataSource = _ref2.dataSource, title = _ref2.title, list = _ref2.list, columns = _ref2.columns, restProps = _objectWithoutProperties(_ref2, _excluded);
          parsedDataSource = parseDataSource(dataSource); // const objectId = findObjectIdByUsedDataContexts(
          //   parsedDataSource.usedContexts,
          //   view.dataSources,
          //   view.variables
          // );
          // const attrViews = objectId
          //   ? await getPreGeneratedAttrViews(objectId)
          //   : undefined;
          configuredItems = new Map(); // if (attrViews?.size && Array.isArray(list)) {
          //   for (const item of list) {
          //     if (item.render) {
          //       continue;
          //     }
          //     if (item.field) {
          //       const candidate = attrViews.get(item.field);
          //       if (candidate) {
          //         const brick = convertToStoryboard(candidate, item.field);
          //         if (brick) {
          //           brick.slot = `[${item.field}]`;
          //           configuredItems.set(item.field, brick);
          //         }
          //       }
          //     }
          //   }
          // }
          if (!Array.isArray(list)) {
            _context2.next = 2;
            break;
          }
          _context2.next = 1;
          return Promise.all(list.map(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref3) {
              var render, item, patterns, useBrick, brick;
              return _regeneratorRuntime().wrap(function (_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    render = _ref3.render, item = _objectWithoutProperties(_ref3, _excluded2);
                    if (!render) {
                      _context.next = 2;
                      break;
                    }
                    patterns = new Map();
                    if (render.params.length > 0) {
                      patterns.set(render.params[0], "DATA");
                    }
                    _context.next = 1;
                    return Promise.all(render.children.map(function (child) {
                      return convertComponent(child, mod, state, options, scope);
                    }));
                  case 1:
                    useBrick = _context.sent.flatMap(function (child) {
                      return deepReplaceVariables(child, patterns);
                    });
                    return _context.abrupt("return", {
                      label: item.label,
                      useBrick: useBrick
                    });
                  case 2:
                    brick = item.field ? configuredItems.get(item.field) : undefined;
                    return _context.abrupt("return", brick ? {
                      label: item.label,
                      useChildren: "[".concat(item.field, "]")
                    } : item);
                  case 3:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x6) {
              return _ref4.apply(this, arguments);
            };
          }()));
        case 1:
          _t = _context2.sent;
          _context2.next = 3;
          break;
        case 2:
          _t = list;
        case 3:
          convertedList = _t;
          return _context2.abrupt("return", {
            brick: "eo-descriptions",
            properties: _objectSpread(_objectSpread(_objectSpread({}, restProps), {}, {
              dataSource: parsedDataSource.isString ? parsedDataSource.embedded : dataSource,
              // descriptionTitle: title,
              list: convertedList
            }, columns == null ? {
              column: options.expanded ? 3 : 1,
              templateColumns: "repeat(auto-fill,minmax(360px,1fr))"
            } : {
              column: columns
            }), {}, {
              // showCard: !options.expanded,
              themeVariant: "elevo"
            }),
            children: configuredItems.size > 0 ? Array.from(configuredItems.values()) : []
          });
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _convertDescriptions.apply(this, arguments);
}
//# sourceMappingURL=convertDescriptions.js.map